import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createPromotionalBlock = (_, params) => {
    return Api(ENDPOINTS.PROMOTIONAL_BLOCK.CREATE, params, requestType.POST);
};

const getAllPromotionalBlocks = (params) => {
    const url = ENDPOINTS.PROMOTIONAL_BLOCK.GET_ALL;

    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append("search", params.search);
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const finalUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    return Api(finalUrl, null, requestType.GET);
};

const getPromotionalBlockDetail = (id) => {
    return Api(ENDPOINTS.PROMOTIONAL_BLOCK.SINGLE.replace(":id", id), null, requestType.GET);
};

const updatePromotionalBlock = (id, params) => {
    return Api(ENDPOINTS.PROMOTIONAL_BLOCK.UPDATE.replace(":id", id), params, requestType.PUT);
};

const deletePromotionalBlock = (id) => {
    return Api(ENDPOINTS.PROMOTIONAL_BLOCK.DELETE.replace(":id", id), null, requestType.DELETE);
};


export {
    createPromotionalBlock,
    getAllPromotionalBlocks,
    getPromotionalBlockDetail,
    updatePromotionalBlock,
    deletePromotionalBlock
};
